import Vue from 'vue';
const $t = Vue.i18n.translate;

export default () => [
    { value: null, text: $t('data.languageLevels.(Seleccionar)', '(Seleccionar)'), disabled: true },
    { value: 'nulo', text: $t('data.languageLevels.nulo', 'Nulo') },
    { value: 'basico', text: $t('data.languageLevels.basico', 'Básico') },
    { value: 'intermedio', text: $t('data.languageLevels.intermedio', 'Intermedio') },
    { value: 'avanzado', text: $t('data.languageLevels.avanzado', 'Avanzado') },
    { value: 'nativo', text: $t('data.languageLevels.nativo', 'Nativo') },
];
